import axios from "axios";
import config from "../../config/config";

const getArtContestData = async (culture, campaignName, nodeId) => {
    const request = axios.get(
        `${config.artContestAppBaseUrl}/GetItems/${culture}/${campaignName}/${nodeId}`,
    );
    try {
        const response = await request;
        return response.data;
    } catch (error) {
        throw new Error(error);
    }
};

const voteArt = async (campaignName, artId) => {
    const request = axios.post(
        `${config.artContestAppBaseUrl}/addVote/${campaignName}/${artId}`, 
        {
            headers: {
                "content-type": "multipart/form-data",
            }
        }
    );
    try {
        const response = await request;
        return response.data;
    } catch (error) {
        throw new Error(error);
    }
};

const undoVoteArt = async (campaignName, artId) => {
    const request = axios.post(
        `${config.artContestAppBaseUrl}/removeVote/${campaignName}/${artId}`, 
        // {
        //     artId: artId
        // }, 
        {
            headers: {
                "content-type": "multipart/form-data",
            }
        }
    );
    try {
        const response = await request;
        return response.data;
    } catch (error) {
        throw new Error(error);
    }
};

export { getArtContestData, voteArt, undoVoteArt };